module.exports = __webpack_public_path__ + "static/media/stash_bag.f5bd0b76.png";